<template lang="html">
  <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
    viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
    <path style="fill:#C2DFF6;" d="M438.512,0v0.084c-22.098,1.327-39.745,19.81-39.745,42.222l0.052,79.376v346.342
      c0,20.061-13.437,36.998-31.805,42.264c-3.866,1.118-7.941,1.714-12.162,1.714H70.615V47.728C70.615,21.367,91.992,0,118.354,0
      H438.512z"/>
    <path style="fill:#D1E7F8;" d="M438.512,0v0.084c-22.098,1.327-39.745,19.81-39.745,42.222l0.052,79.376v346.342
      c0,20.061-13.437,36.998-31.805,42.264c-3.866,1.118-7.941,1.714-12.162,1.714H110.319V47.728C110.319,21.367,131.696,0,158.057,0
      H438.512z"/>
    <path style="fill:#78B9EB;" d="M483.962,42.316v53.109c0,14.502-11.754,26.257-26.246,26.257h-58.939V42.316
      C398.777,19.047,417.813,0,441.082,0h0.564c14.157,0,26.758,7.053,34.438,17.814C481.036,24.742,483.962,33.205,483.962,42.316z"/>
    <path style="fill:#96C8EF;" d="M350.349,511.666v0.324H72.193v-0.042c-0.428,0.01-0.846,0.031-1.275,0.031h-0.575
      c-20.583,0-37.854-14.889-41.563-34.438c-0.491-2.549-0.742-5.182-0.742-7.868v-53.119c0-14.492,11.754-26.246,26.246-26.246
      h232.674c14.492,0,26.246,11.754,26.246,26.246v53.119c0,2.685,0.251,5.318,0.742,7.868
      C317.342,495.429,332.085,509.43,350.349,511.666z"/>
    <path style="fill:#78B9EB;" d="M350.349,511.666v0.324H72.193v-0.042c-0.428,0.01-0.846,0.031-1.275,0.031h-0.575
      c-20.583,0-37.854-14.889-41.563-34.438h285.167C317.342,495.429,332.085,509.43,350.349,511.666z"/>
    <g>
      <path style="fill:#5AAAE7;" d="M138.062,146.594h192.762c4.328,0,7.836-3.509,7.836-7.836c0-4.328-3.509-7.836-7.836-7.836H138.062
        c-4.328,0-7.836,3.509-7.836,7.836C130.226,143.086,133.734,146.594,138.062,146.594z"/>
      <path style="fill:#5AAAE7;" d="M330.824,195.176H138.062c-4.328,0-7.836,3.509-7.836,7.836c0,4.328,3.509,7.836,7.836,7.836
        h192.762c4.328,0,7.836-3.509,7.836-7.836C338.661,198.685,335.151,195.176,330.824,195.176z"/>
      <path style="fill:#5AAAE7;" d="M330.824,259.431H138.062c-4.328,0-7.836,3.509-7.836,7.836s3.509,7.836,7.836,7.836h192.762
        c4.328,0,7.836-3.509,7.836-7.836S335.151,259.431,330.824,259.431z"/>
      <path style="fill:#5AAAE7;" d="M330.824,323.685H138.062c-4.328,0-7.836,3.509-7.836,7.836s3.509,7.836,7.836,7.836h192.762
        c4.328,0,7.836-3.509,7.836-7.836S335.151,323.685,330.824,323.685z"/>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'Bells'
}
</script>



// WEBPACK FOOTER //
// src/components/primitives/icons/BidNotice.vue